module.exports = "/packs/007-e93fa18ecb681e1d846bb8e589bb992b.jpg";